import { FC } from "react";
import classes from "./LayoutContainer.module.scss";

type LayoutContainerType = {
  children: React.ReactNode;
};

const LayoutContainer: FC<LayoutContainerType> = ({ children }) => {
  return <div className={classes.container}>{children}</div>;
};

export default LayoutContainer;
